import React from "react";
import ForoJNE from "../images/contenido/ForoJNE.jpg";
import ForoIquitos from "../images/contenido/ForoIquitos.jpg";
import DaniloMartuccelli from "../images/contenido/DaniloMartuccelli.jpg";
import MesaVerde from "../images/contenido/MesaVerde.jpg";
import Webinar1 from "../images/contenido/Webinar1.jpg";
import Webinar2 from "../images/contenido/Webinar2.jpg";
import Webinar3 from "../images/contenido/Webinar3.jpg";
import Webinar4 from "../images/contenido/Webinar4.jpg";
import Webinar5 from "../images/contenido/Webinar5.jpg";
import VideoNatalia from "../images/contenido/VideoNatalia.jpg";
import VideoRicardo from "../images/contenido/VideoRicardo.jpg";
import Navigation from "../components/Navigation";
import { Helmet } from "react-helmet";

const DebateEducacion = () => {
  return (
    <section className="nosotros">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Debate sobre la educación como problema - Memoria 2014-2024 -
          Fundación Gustavo Mohme Llona
        </title>
        <meta
          property="og:title"
          content="Debate sobre la educación como problema - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <div className="pre-title">3.2</div>
            <h1 className="color-green">
              Debate sobre la educación como problema
            </h1>
          </div>
          <div className="column-0">
            <div className="cont-mohme-0">
              <img
                src={ForoJNE}
                alt="Foro ¿Por qué formamos ciudadanos?"
                className="mohme-0 border-img"
              />
              <div className="legend">
                Foro "¿Por qué formamos ciudadanos?" con Antonio Zapata, Natalia
                González y Juan de la Puente.
              </div>
              <div className="block-green"></div>
            </div>
            <div className="block-green-light"></div>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <p>
              Más allá de la provisión de recursos para el fomento de la
              educación ciudadana, la fundación ha considerado necesario
              promover la reflexión en torno a la compleja situación de la
              educación en nuestro país. En esa línea, ha impulsado, desde
              distintas plataformas, espacios de discusión sobre temas y
              problemas estructurales y coyunturales de interés para los
              distintos actores del ecosistema educativo del Perú.
            </p>

            <h4>3.2.1 FOROS SOBRE CIUDADANÍA CON EL JNE</h4>
            <figure className="img-right img-m">
              <div className="block-green-light"></div>
              <img
                src={ForoIquitos}
                alt="Foro 'Pienso, decido y voto'"
                className="img-m"
              />
              <div className="legend">
                Foro "Pienso, decido y voto" con la presencia de Milagros Suito
                y Javier Torres Seoane en Iquitos el año 2018.
              </div>
            </figure>
            <p>
              Teniendo como objetivo compartido el de construir ciudadanía, la
              Dirección Nacional de Educación Electoral del Jurado Nacional de
              Elecciones y la Fundación Gustavo Mohme Llona organizaron el 2018
              una serie de foros orientados a promover el debate “¿Por qué
              formamos ciudadanos?”, en torno a la necesidad de educar en
              valores democráticos desde la educación básica. Asimismo,
              presentaron los foros ciudadanos “Pienso, decido y voto”, en el
              contexto de las elecciones regionales y municipales de ese año.
              Las charlas fueron realizadas en cinco departamentos del Perú
              (Piura, Puno, Cusco, Ayacucho y Apurímac), entre los meses de
              junio y setiembre, y contaron con la participación del antropólogo
              Javier Torres Seoane y representantes del JNE. El público objetivo
              fueron los miembros de las organizaciones sociales, maestros,
              periodistas y el electorado de cada región.
            </p>

            <h4>
              3.2.2 MESA VERDE: “PROBLEMATIZACIONES DE LA PARTICIPACIÓN
              CIUDADANA”
            </h4>

            <p>
              Coorganizada con el Instituto de Estudios Peruanos (IEP) y el
              Instituto Francés de Estudios Andinos (IFEA), se realizó el 5 de
              julio del 2018 y contó con la participación del sociólogo Danilo
              Martuccelli, profesor de la Universidad París Descartes; y del
              psicólogo e investigador principal del IEP, Ricardo Cuenca. En
              ella se discutió acerca de las limitaciones para la participación
              política de la ciudadanía, las dinámicas contemporáneas de la
              acción colectiva y las posibilidades reales de cambio social desde
              instancias como la escuela y otros espacios de formación
              ciudadana.
            </p>
            <div className="card">
              <div className="quote-green">
                <p>
                  La fundación promueve espacios de diálogo y reflexión sobre el
                  quehacer pedagógico y la política educativa en nuestro país.
                </p>
              </div>
              <div>
                <img
                  src={DaniloMartuccelli}
                  alt="Danilo Martuccelli"
                  className="img-responsive"
                />
              </div>
            </div>
            <div className="card-legend">
              <div className="legend">
                Danilo Martuccelli durante la conferencia sobre la participación
                ciudadana.
              </div>
            </div>
            <figure className="img-center">
              <div className="block-green"></div>
              <img src={MesaVerde} alt="Mesa Verde" className="" />
              <div className="legend">
                Mesa verde en el tradicional local del IEP.
              </div>
            </figure>
            <h4>
              3.2.3 CICLO DE WEBINARIOS: “APRENDIZAJES CIUDADANOS PARA LA
              ESCUELA”
            </h4>
            <p>
              En el contexto de la pandemia, durante el 2021, la fundación, en
              colaboración con el Instituto de Estudios Peruanos, organizó una
              serie de webinarios y produjo videos para ser compartidos desde
              sus redes sociales (Facebook y Twitter) y las del Grupo La
              República. En ellos se abordaron temas coyunturales de interés
              para docentes, directivos y funcionarios del sector educación
              durante la emergencia sanitaria. Cada edición contó con la
              presentación de Stella Mohme Seminario, directora de la Fundación
              Gustavo Mohme Llona; y Natalia González, directora del IEP.
            </p>
            <div className="row-content bg-green">
              <div className="col">
                <div>
                  <img
                    src={Webinar1}
                    alt="Webinar 1"
                    className="img-responsive"
                  />
                </div>
                <h5>
                  Webinario 1: “Las claves para abordar las elecciones en la
                  escuela”
                </h5>
                <small>(24 de marzo del 2021)</small>
                <p>
                  Invitados: Jorge Aragón, investigador principal del Instituto
                  de Estudios Peruanos (IEP) y docente del Departamento
                  Académico de Ciencias Sociales de la PUCP; y Alejandra Alegre,
                  politóloga por la PUCP.
                </p>
                <p>11 000 reproducciones + 3 000 (VOD)</p>
              </div>
              <div className="col">
                <div>
                  <img
                    src={Webinar2}
                    alt="Webinar 2"
                    className="img-responsive"
                  />
                </div>
                <h5>
                  Webinario 2: “Aprendizajes urgentes para la escuela en tiempos
                  de pandemia”
                </h5>
                <small>(5 de mayo del 2021)</small>
                <p>
                  Invitados: Mariana Eguren, lingüista por la Pontificia
                  Universidad Católica del Perú (PUCP) e investigadora principal
                  del Instituto de Estudios Peruanos (IEP); y Miguel Cruzado,
                  sociólogo por la Pontificia Universidad Católica del Perú
                  (PUCP) y consultor educativo.{" "}
                </p>
                <p>9 472 reproducciones</p>
              </div>
              <div className="col">
                <img
                  src={Webinar3}
                  alt="Webinar 3"
                  className="img-responsive"
                />
                <h5>
                  Webinario 3: “Historia y ciudadanía: lo que se aprende en la
                  escuela”
                </h5>
                <small>(9 de junio del 2021)</small>
                <p>
                  Invitados: Raúl H. Asensio, director de publicaciones del IEP;
                  y Lilia Calmet, directora de formación inicial ITS.
                </p>
                <p>17 100 reproducciones + 27 000 VOD</p>
              </div>
              <div className="col">
                <img
                  src={Webinar4}
                  alt="Webinar 4"
                  className="img-responsive"
                />
                <h5>Webinario 4: “Agenda educativa: avances y riesgos”</h5>
                <small>(7 de setiembre del 2021)</small>
                <p>
                  Invitados: Patricia Salas, exministra de Educación
                  (2011-2013); Ricardo Cuenca, exministro de Educación
                  (2020-2021); y Miguel Lizano, docente del colegio José Olaya
                  de Piura y exdirector de la UGEL de Sullana.
                </p>
                <p>6 523 reproducciones + 2 659 (VOD)</p>
              </div>
              <div className="col">
                <img
                  src={Webinar5}
                  alt="Webinar 5"
                  className="img-responsive"
                />
                <h5>
                  Webinario 5: “El regreso a clases y el reto de la convivencia
                  desde la escuela”
                </h5>
                <small>(26 de octubre del 2021)</small>
                <p>
                  Invitadas: Patricia Andrade, exviceministra de Educación; y
                  Cristina Glave, investigadora asociada de Apoyo Consultoría.
                </p>
                <p>5 752 reproducciones + 5 200 (VOD)</p>
              </div>
            </div>
            <div className="quote quote-center quote-green">
              <p>
                La pandemia obligó a llevar la reflexión hacia formatos
                digitales para seguir debatiendo e incidiendo en la política
                educativa.
              </p>
            </div>
            <h4>3.2.4 VIDEOS SOBRE COYUNTURA EDUCATIVA</h4>
            <p>
              Asimismo, la fundación editó y publicó videos explicativos sobre
              los problemas enfrentados por el sector educación en los primeros
              meses del año 2022. En esta oportunidad también contó con el apoyo
              de los especialistas del IEP.
            </p>
            <div className="row-content bg-green">
              <div className="col videos-coyuntura">
                <img
                  src={VideoNatalia}
                  alt="Natalia"
                  className="img-responsive img-small"
                />
                <h5>
                  Video 1: ¿Cuál es el peligro del proyecto de ley sobre textos
                  escolares?
                </h5>
                <p>
                  Expositora: Natalia González, directora e investigadora del
                  IEP.
                </p>
                <p>2 058 reproducciones</p>
              </div>
              <div className="col videos-coyuntura">
                <img
                  src={VideoRicardo}
                  alt="Ricardo"
                  className="img-responsive img-small"
                />
                <h5>Video 2: ¿Qué es la contrarreforma universitaria?</h5>
                <p>
                  Expositor: Ricardo Cuenca, exministro de Educación e
                  investigador del IEP.
                </p>
                <p>3 200 reproducciones</p>
              </div>
            </div>
          </div>
          <Navigation
            prev="https://fundacionmohme.org/especiales/memoria-2024/proyecto-democracia"
            textPrev="3.1 Proyecto Democracia: construyendo ciudadanía desde la escuela"
            next="https://fundacionmohme.org/especiales/memoria-2024/#otros"
            textNext="4. Otras iniciativas"
          />
        </div>
      </div>
    </section>
  );
};

export default DebateEducacion;
